import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/acquisitions-incorporated': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M357.4 468.2c2.2 14.3 4.1 28.7 6.6 43.7h-337.1c-4 0-6.1-0.7-5.3-5.7 2.1-12.9 3.5-25.9 5-38.8 0.5-4.8 2.3-6.8 7.6-6.8 118.1 1 114.9 0.3 121.4-2.4 9.4-4 14.9-12.9 14.9-23.1-0.1-42.9-0.3-85.9-0.2-128.8 0-3.8-1.2-5.9-4.6-6.8-15.7-3.9-31.3-7.7-47.6-11.7-5.3 12.3-10.4 24.4-15.7 36.7 1.8 3.3 28.4 2.9 35.3 2.9v27.6h-114.3c1-8.6 1.7-16.8 3.2-24.9 0.3-1.4 3.6-3.1 5.5-3.2 8.4-0.4 16.9-0.3 25.4-0.1 4 0 5.9-1.1 7.6-5.2 16.6-40.7 13.5-31.2 67.3-161 31.5-76.1 33-76 32.6-87.4-0.7-18.6-25.4-22.3-37.7-22.1-30 0.4-38.4-0.5-101.8-0.5-7.2-44.5-4.2-32.1-6.4-45.3-0.7-4.2 1-5.3 4.6-5.3l339.1 0.2c-0.8 5.4-1.6 10.8-2.4 16.1-1.3 9.7-2.8 19.4-4 29.2-0.3 2.9-1.2 4.3-4.3 4.3-20.6 0.1-41.2 0.1-61.8 0.5-18.7 0.4-37.6 0.3-56.2 2-13.4 1.2-23.3 12.6-18.9 26.6 8.6 27.1 27.7 69.1 36.5 89.2 65.7 154.2 61.4 157 84 158.6 6.6 0.5 13.4 0.1 20.4 0.1 1.3 9.4 2.6 18 4 27.5h-116v-27c10.4 0 20.4-0.1 30.4 0.1 3.5 0 5-0.7 3.4-4.4-4.4-10.3-8.7-20.6-13.2-30.9-1.6-3.7-4.1-4.8-8.4-3.5-12.4 3.6-24.8 6.7-37.3 9.7-4.3 1.1-6 2.8-5.9 7.5 0.8 57.5 0.9 127.5 1 129.1 0.4 12.6 8.7 21.4 21 23.1 0.9 0.2 12.9 2.8 112.7 2.6 8.3 0 8.4-0.1 9.6 7.6zM182.6 262.5c2.5 0.9 6.6 1.6 9.2 1.6s6.7-0.7 9.2-1.6c13-4.2 26.3-7.8 39.4-11.7 1.1-0.5 2.9-1.5 3.9-2.1-6.7-17.4-13.1-34.2-19.7-50.9-8.9-22.7-17.7-60.3-27-82.8-1.5-0.8-1.9 2.4-9.4 0-17.1 44-34.1 87.8-51.3 132.1 1.5 0.9 4.1 2.2 5.8 2.9 13.3 4.3 26.6 8.3 39.9 12.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/acquisitions-incorporated.js
// module id = 695
// module chunks = 0